var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column is-4 flex flex-vertical-center flex-between motivator_item",class:{'is-true': _vm.value}},[_c('p',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.value ? 'Yes' : 'No'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }